var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.complaint
    ? _c(
        "div",
        {
          staticClass: "mb35 p20 brdr-1 brdr-cl-primary bg-cl-white",
          staticStyle: { "border-radius": "30px" }
        },
        [
          _c("div", { staticClass: "row mb15" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-md-2 col-lg-1" },
              [_c("return-icon", { staticClass: "p12 icon pointer" })],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-6" }, [
              _c("h3", { staticClass: "m0 mb5 mt5" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("Complaint ")) +
                    " " +
                    _vm._s(
                      _vm.complaint.rma_number
                        ? _vm.complaint.rma_number
                        : _vm.complaint.id
                    ) +
                    "\n        "
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row fs16 mb10" }, [
            _c("div", { staticClass: "col-xs-6 h4" }, [
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("Create date")) +
                    ": " +
                    _vm._s(
                      _vm._f("date")(
                        _vm.complaint.created,
                        "LLL",
                        _vm.storeView
                      )
                    )
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-6 h4" }, [
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("Created by")) +
                    ": " +
                    _vm._s(_vm.complaint.name)
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row fs16 mb10" }, [
            _c("div", { staticClass: "col-xs-6 h4" }, [
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("RMA ")) +
                    ": " +
                    _vm._s(_vm.getRMAType(_vm.complaint.rma_type))
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-6 h4" }, [
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("Status")) +
                    ": " +
                    _vm._s(_vm._f("capitalize")(_vm.complaint.status))
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row fs16 mb10" }, [
            _c("div", { staticClass: "col-xs-12 h4" }, [
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("Description")) +
                    ": " +
                    _vm._s(_vm.complaint.description)
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row fs16 mb35" }, [
            _vm.complaint.rma_type === "service"
              ? _c("div")
              : _c("div", { staticClass: "col-xs-12 h4" }, [
                  _c("h4", [_vm._v(_vm._s(_vm.$t("Complaint items")))]),
                  _vm._v(" "),
                  _c("table", { staticClass: "brdr-1 brdr-cl-bg-secondary" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", { staticClass: "sans-serif lh20" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("BP model")) +
                              "\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "sans-serif lh20" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.complaint.rma_type === "RMA_Zwrot" ||
                                  _vm.complaint.rma_type === "Zwrot"
                                  ? _vm.$t("Qty")
                                  : _vm.$t("Printer")
                              ) +
                              "\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "sans-serif lh20" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.complaint.rma_type === "RMA_Zwrot" ||
                                  _vm.complaint.rma_type === "Zwrot"
                                  ? _vm.$t("Invoice")
                                  : _vm.$t("Reason")
                              ) +
                              "\n            "
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.complaint.items, function(item) {
                        return _c(
                          "tr",
                          {
                            key: item.sku,
                            staticClass: "brdr-top-1 brdr-cl-bg-secondary"
                          },
                          [
                            _c(
                              "td",
                              {
                                staticClass: "fs-medium lh25",
                                attrs: { "data-th": _vm.$t("SKU") }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.part_number) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "fs-medium lh25",
                                attrs: { "data-th": _vm.$t("Qty") }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.complaint.rma_type === "RMA_Zwrot" ||
                                        _vm.complaint.rma_type === "Zwrot"
                                        ? item.quantity
                                        : item.device
                                    ) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "fs-medium lh25",
                                attrs: { "data-th": _vm.$t("Reason") }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.complaint.rma_type === "RMA_Zwrot" ||
                                        _vm.complaint.rma_type === "Zwrot"
                                        ? item.invoice
                                        : item.reason
                                    ) +
                                    "\n            "
                                )
                              ]
                            )
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm._m(0)
                  ])
                ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row fs16 mb35" }, [
            _c(
              "div",
              { staticClass: "col-xs-2" },
              [
                _c("complaint-pdf", {
                  attrs: { currentComplaint: _vm.complaint }
                }),
                _vm._v(" "),
                _c(
                  "button-full",
                  {
                    attrs: { type: "button" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.$bus.$emit("download-pdf")
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("Download PDF")) +
                        "            \n      "
                    )
                  ]
                )
              ],
              1
            )
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tfoot", [
      _c("tr", { staticClass: "brdr-top-1 brdr-cl-bg-secondary" }, [
        _c("td", { staticClass: "align-right", attrs: { colspan: "5" } }),
        _vm._v(" "),
        _c("td")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }